export const DateRange = ({timespan, setTimespan}) => {
 return <div style={{display: 'inline-block'}}> 
<label for="dateRange">Time Range:</label>
<select name="dateRange" id="dateRange" value={timespan} onChange={(e) => setTimespan(e.target.value)} >
    <option value="month">Past Month</option>
    <option value="week">Past Week</option>
    <option value="day">Past Day</option>
    <option value="hour">Past Hour</option>
</select>
 </div>
}